import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CONDITION } from "./abstract/conditionAbstract";

const _action = `${ACTION_PREFIX_CONDITION}_create`;
const _header = `Create parameter`;

export const addCondition = (root, idParent, body, index) => {
  const _payload = addConditionLogic(root, idParent, body, index);

  logger.logAction(_action, _payload, ACTION_PREFIX_CONDITION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const addConditionLogic = (root, idParent, body, index) => {
  const { data: _nodeParent } = getNodeById(root, idParent);
  if (!_nodeParent) {
    throw new Error("Invalid idparent");
  }
  const _indexParsed = index ?? nodeUtils.getConditions(_nodeParent).length;

  const fun = (e) => e.splice(_indexParsed, 0, body);
  nodeUtils.modifyConditions(_nodeParent, fun, false);

  return generatePayload(body, _indexParsed, _nodeParent);
};

//--------------------------------------------------------------------------------

const generatePayload = (body, index, nodeParent) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(nodeParent),
    node: systemUtils.createDeepCopy(body),
    uuid: nodeUtils.getUUID(body),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
  };

  return _payload;
};


const generatePayloadDescription = (nodeParent) => {

  if (nodeUtils.isFunction(nodeParent)) {
    return `Add a new logic to function '${nodeUtils.getName(nodeParent)}'.`;
  }

  return `Add a new logic to structure '${nodeUtils.getName(nodeParent)}'.`;
}